import Vue from "vue";
import axios from 'axios';
import VueAxios from "vue-axios";
import store from './store/index.js'
import { SETERROR } from './store/index.js'
import JwtService from "@/core/services/jwt.service";
import router from "@/router";
import { message } from 'ant-design-vue'
// import { AUTHORIZATION } from '@/core/config/userConfig.js'
const qs = JSON;
//设置请求类型
const AxiosType = {
  init(config, data) {
    let { type, headers } = config, dataVal;
    switch (type) {
      case 'file':
        dataVal = this.file(data);
        headers['Content-Type'] = 'multipart/form-data';
        break;
      case 'json':
        dataVal = this.addJSON(data);
        headers['Content-Type'] = 'application/json; charset=utf-8';
        break;
      case 'listjson':
          dataVal = data;
          headers['Content-Type'] = 'application/json; charset=utf-8';
          break;
      default:
        dataVal = this.getFormData(data);
        headers['Content-Type'] = 'application/x-www-form-urlencoded';
    }
    return dataVal;
  },

  addJSON(data) {
    const obj = {};
    Object.keys(data).forEach((key) => {
      if (typeof data[key] !== 'undefined' && data[key] !== '' && data[key] !== null) {
        obj[key] = data[key];
      }
    });
    return qs.stringify(obj);
  },

  file(data) {
    const formData = new FormData();
    Object.keys(data).forEach((key) => {
      if (typeof data[key] !== 'undefined' && data[key] !== '' && data[key] !== null) {
        formData.append(key, data[key]);
      }
    });
    return formData;
  },

  getFormData(data) {
    const params = new URLSearchParams();
    Object.keys(data).forEach((key) => {
      if (typeof data[key] !== 'undefined' && data[key] !== '' && data[key] !== null) {
        params.append(key, data[key]);
      }
    });
    return params;
  }
}
//401更新token
// const updateToken = (config, resolve, reject) => {
//   ApiService.post('/api-uaa/oauth/token',
//     { grant_type: 'refresh_token', refresh_token: JwtService.getRefreshToken() },
//     {
//       headers: { Authorization: AUTHORIZATION }
//     }
//   ).then((data) => {
//     JwtService.saveToken(data.access_token);
//     JwtService.saveRefreshToken(data.refresh_token);
//     updataAjax(config, resolve, reject);
//   }).catch(() => {
//     location.href = `${location.origin}/#/login?redirect=${config.url}`;
//   })
// }
//重新请求
// const updataAjax = (config, resolve, reject) => {
//   ApiService.setHeader(config.headers)
//   if (config.method === 'get' || config.method === 'delete') {
//     Vue.axios[config.method](config.url, { headers: config.headers }).then((data) => {
//       ApiService.then(data, resolve, reject)
//     }).catch((error) => {
//       ApiService.catch(error, reject)
//     })
//   } else {
//     Vue.axios[config.method](config.url, config.data, { headers: config.headers }).then((data) => {
//       ApiService.then(data, resolve, reject)
//     }).catch((error) => {
//       ApiService.catch(error, reject)
//     })
//   }
// }
/**
 * Service to call HTTP request via Axios
 */
const ApiService = {
  init() {
    Vue.use(VueAxios, axios);
    // Vue.axios.defaults.baseURL = "http://localhost";
    // Vue.axios.defaults.baseURL = "http://49.65.229.184:9900";
  },

  /**
   * Set the default HTTP request headers
   */
  setHeader(headers = {}) {
    if (!headers['Authorization'] || headers['Authorization'].indexOf('bearer') !== -1) {
      let token = JwtService.getToken();
      headers['Authorization'] = `bearer ${token}`;
    }

  },
  addDataAndHeader(config = {}, params = {}) {
    config.headers = config.headers || {}
    this.setHeader(config.headers);
    var data = AxiosType.init(config, params);
    return data;
  },
  then(other, resolve, reject) {
    var { resp_code, resp_msg, datas } = other.data || {}
    if (parseInt(resp_code) !== 0) {
      store.dispatch(SETERROR, resp_msg);
      message.error(resp_msg);
      reject(resp_msg);
    } else {
      resolve(datas);
    }
  },
  catch({ response }, reject) {
    if (response.status === 401) {
      if (location.hash !== "#/login") {
        router.push({ path: '/login', query: { redirect: location.hash.split('#/')[1] } });
      }
      reject(response.data.resp_msg);
      message.error(response.data.resp_msg);
      // location.href = `${location.origin}/#/login?redirect=${location.hash.split('#/')[1]}`;
      // updateToken(config, resolve, reject);
    } else {
      store.dispatch(SETERROR, response.data.resp_msg);
      message.error(response.data.resp_msg);
      reject(response.data.resp_msg);
    }


  },
  query(resource, params) {
    return new Promise((resolve, reject) => {
      Vue.axios.get(resource, params).catch(error => {
        // console.log(error);
        reject(new Error(`[KT] ApiService ${error}`));
      });
    })

  },
  /**
   * Send the GET HTTP request
   * @param resource
   * @param config
   * @returns {*}
   */
  get(resource, config = {}) {
    config.headers = config.headers || {}
    this.setHeader(config.headers);
    return new Promise((resolve, reject) => {
      Vue.axios.get(resource, config).then((data) => {
        this.then(data, resolve, reject)
      }).catch((E) => { this.catch(E, reject) })
    })

  },
  /**
   * Set the POST HTTP request
   * @param resource
   * @param params
   * @param config
   * @returns {*}
   */
  post(resource, params = {}, config = {}) {
    var data = this.addDataAndHeader(config, params);
    return new Promise((resolve, reject) => {
      Vue.axios.post(`${resource}`, data, config).then((obj) => {
        this.then(obj, resolve, reject)
      }).catch((e) => {
        this.catch(e, reject)
      });
    })
  },
  post2(resource, params = {}, config = {}) {
    var data = this.addDataAndHeader(config, params);
    return new Promise((resolve, reject) => {
      Vue.axios.post(`${resource}`, data, config).then((obj) => {
        resolve(obj)
      }).catch((e) => {
        this.catch(e, reject)
      });
    })
  },

  /**
   * Send the UPDATE HTTP request
   * @param resource
   * @param slug
   * @param params
   * @returns {IDBRequest<IDBValidKey> | Promise<void>}
   */
  update(resource, params = {}, config = {}) {
    var data = this.addDataAndHeader(config, params);
    return new Promise((resolve, reject) => {
      Vue.axios.put(`${resource}`, data, config).then((obj) => {
        this.then(obj, resolve, reject)
      }).catch((e) => {
        this.catch(e, resolve, reject)
      });
    })

  },

  /**
   * Send the PUT HTTP request
   * @param resource
   * @param params
   * @returns {IDBRequest<IDBValidKey> | Promise<void>}
   */
  put(resource, params = {}, config = {}) {
    var data = this.addDataAndHeader(config, params);
    return new Promise((resolve, reject) => {
      Vue.axios.put(`${resource}`, data, config).then((obj) => {
        this.then(obj, resolve, reject)
      }).catch((e) => {
        this.catch(e, reject)
      });
    })

  },

  /**
   * Send the DELETE HTTP request
   * @param resource
   * @returns {*}
   */
  delete(resource, config = {}) {
    this.addDataAndHeader(config);
    return new Promise((resolve, reject) => {
      Vue.axios.delete(resource, config).then(obj => {
        resolve(obj)
      }).catch((e) => {
        this.catch(e, reject)
      });
    })

  }
};

export default ApiService;
